module.exports = __webpack_public_path__ + "img/truncus.ce5a6e56.png";